// extracted by mini-css-extract-plugin
export default {"container":"_924b0f05","buttonWrapper":"_6a3e3a07","button":"_84f9cd54","spinner":"_2f96555f","error":"_ec20ae9a","successTitle":"_1a61c01","inboxLink":"_ad2cac70"};